import React from "react";
import { Link } from "react-router-dom";

const LandingNav = () => {
  return (
    <div>
      <div className="w-full fixed top-0 left-0 z-10 navbar">
        <div className="flex items-center justify-between  py-3 md:px-16 px-4">
          <Link
            to="/"
            className="font-bold  cursor-pointer flex items-center  border border-gray-800 px-2 py-1 rounded-sm backdrop-blur-lg
      text-gray-800"
          >
            MEDSHOW
          </Link>

          <Link
            to="/signin"
            className="px-4 inline-flex items-center  py-2 rounded-lg bg-white border border-black shadow-[5px_5px_black] hover:shadow-none duration-200"
          >
            <span>Sign In</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LandingNav;
